import useSessionStore from '@/stores/session';
import api from '@/helpers/api.js';
import { axios } from '@/plugins/axios.js';
import { redirectUrl, reloadBrowserWindow } from '@/plugins/cdc/auth/auth-shared.js';
import { isCdcAvailable } from '@/plugins/cdc/shared.js';


/**
 * Handles the logout procedure.
 */
export function performLogout() {
  try {
    const sessionStore = useSessionStore();

    if (sessionStore) {
      sessionStore.globalLoader = true;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  commerceLogout().finally(() => pimcoreLogout());
}

/**
 * Logs the user out from CDC.
 *
 * @param {String} [redirectTo] - Accepts an optional redirect url to be called after logout.
 */
export function performCdcLogout(redirectTo = null) {
  redirectUrl.value = redirectTo;

  if (isCdcAvailable()) {
    window?.gigya?.accounts?.logout();
  } else {
    // eslint-disable-next-line no-console
    console.error('CDC could not been loaded.');
    pimcoreLogout();
  }
}

/**
 * Logout from e-commerce system.
 *
 * @returns {Promise}
 */
export function commerceLogout() {
  const sessionStore = useSessionStore();
  const url = sessionStore.isMiniPortal ? api.getUrl('portal-logout') : api.getUrl('shop-logout');

  // Axios was used to prevent default error handling.
  return axios.post(url);
}

/**
 * Sends a logout event to the pimcore to logout the user from pimcore.
 */
export function pimcoreLogout() {
  const sessionStore = useSessionStore();

  api
    .get(api.getUrl('pimcore-logout'))
    .then(() => {
      sessionStore.globalLoader = false;

      if (redirectUrl.value) {
        redirectUrl.value = null;

        reloadBrowserWindow(redirectUrl.value);
      } else {
        reloadBrowserWindow();
      }
    })
    .catch((error) => {
      sessionStore.globalLoader = false;

      throw error;
    });
}
